import React, { Component } from "react";
import ReportsViewTable from "../../components/reportmanagement/reportsViewTable";
import { Link } from "react-router-dom";
import Timezone from "../../components/common/Timezone";
import Back from "../../components/common/Back";
import getCobrand from "../../util/getCobrand";

class PrintView extends Component {
  state = {
    cobrand: getCobrand()
  };

  render(props) {
    let reports = {},
      reportName = "",
      fromDate = "",
      toDate = "",
      duration = "",
      reportId = "",
      cobrandId = "";

    if (
      this.props.location.printVals &&
      this.props.location.printVals.reports
    ) {
      reports = this.props.location.printVals.reports;
      reportId = this.props.location.printVals.reportId;
      reportName = this.props.location.printVals.reportName;
      fromDate = this.props.location.printVals.fromDate;
      toDate = this.props.location.printVals.toDate;
      cobrandId = this.props.location.printVals.cobrandId;
      duration = this.props.location.printVals.duration;
      localStorage.setItem(
        "printVals",
        JSON.stringify(this.props.location.printVals)
      );
    } else if (localStorage.getItem("printVals")) {
      reports = JSON.parse(localStorage.getItem("printVals")).reports;
      reportId = JSON.parse(localStorage.getItem("printVals")).reportId;
      reportName = JSON.parse(localStorage.getItem("printVals")).reportName;
      fromDate = JSON.parse(localStorage.getItem("printVals")).fromDate;
      toDate = JSON.parse(localStorage.getItem("printVals")).toDate;
      cobrandId = JSON.parse(localStorage.getItem("printVals")).cobrandId;
      duration = JSON.parse(localStorage.getItem("printVals")).duration;
    } else {
      localStorage.setItem("printVals", "");
    }
    return (
      <React.Fragment>
        <div className="container main">
          <div className="mt-4">
            <Back uri={"/reports/" + cobrandId} />
          </div>
          <div class="heading mt-4">{reportName}</div>
          <div className="sub-heading mt-2">
            <span> COBRAND: </span>
            {this.state.cobrand.name} - {this.state.cobrand.id}
          </div>
          <div className="sub-heading mb-4">
            <span> DURATION: </span>
            {duration} ( {fromDate} - {toDate} )
          </div>

          <div className="row">
            <div className="col-12 text-right mb-4">
              <button
                className="btn btn-secondary btn-sm nonPrintable"
                style={{ float: "right" }}
                onClick={window.print}
              >
                <i className="fas fa-print form-control-feedback" />
                &nbsp;Print
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col">
              {(reportId === "101" || reportId === "102") && (
                <Timezone label="* Times are displayed in" />
              )}
              <ReportsViewTable
                reports={reports}
                reportId={reportId}
                pagination={false}
                paginationPerPage={0}
                paginationRowsPerPageOptions={[]}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default PrintView;
